import {Injectable} from '@angular/core';
import {CategoriasResource} from './categorias.resource';
import {CategoriaModel} from './categoria';

@Injectable({
  providedIn: 'root'
})
export class CategoriasService {

  constructor(private categoriaResource: CategoriasResource) {}

  public lodCategoria(id: string): Promise<CategoriaModel> {
    return this.categoriaResource.lodCategoria({id: id});
  }

  public lodListaCategorias(filtros: any): Promise<CategoriaModel[]> {
    return this.categoriaResource.lodListaCategorias(filtros);
  }

  public lodListaCategoriasActivas(): Promise<CategoriaModel[]> {
    return this.categoriaResource.lodListaCategoriasActivas();
  }

  public crtCategoria(categoria: CategoriaModel): Promise<any> {
    return this.categoriaResource.crtCategoria(categoria);
  }

  public updCategoria(categoria: CategoriaModel): Promise<any> {
    return this.categoriaResource.updCategoria(categoria);
  }

  public lodCategoriasBusqueda(s: any): Promise<CategoriaModel[]> {
    return this.categoriaResource.lodListaCategoriasPublic(s);
  }

  public lodCategoriaPublic(categoria): Promise<CategoriaModel> {
    return this.categoriaResource.lodCategoriaPublic(categoria);
  }

  public lodCategoriaNombre(id: string): Promise<CategoriaModel> {
    return this.categoriaResource.lodCategoriaNombre({id: id});
  }
}
